import { DESKTOP_QUERY, useMediaQuery } from '../../shared/ui/useMediaQuery.js';

/**
 * Navigatsiya MOBIL ko'rinishda chizilsinmi.
 *
 * Chegara butun ilova bilan bitta (`DESKTOP_QUERY`, 1024px) va bu shart:
 * header shu nuqtada til va mavzu tugmalarini «Menyu» sheet ichiga
 * beradi. Ikki xil chegara bo'lsa, oraliqda tugmalar header'dan ketgan,
 * sheet esa hali paydo bo'lmagan holat yuzaga kelardi.
 *
 * Tanlov CSS da emas, shu yerda: bir xil menyuni ikki marta chizib,
 * birini `hidden` bilan yashirish ekran o'qigichga ikkita bir xil `nav`
 * beradi va bo'limlar ro'yxati ikkilanadi.
 *
 * `matchMedia` bo'lmagan muhitda `useMediaQuery` KENG ekranga qaytadi —
 * ya'ni bu yerda `false`, yon panel. Yig'ilgan mobil tartib — istisno,
 * yon panel esa odatiy ko'rinish.
 */
export const useMobileNav = (): boolean => !useMediaQuery(DESKTOP_QUERY);
